import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  Container,
  TextField,
  Button,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getCountryData } from "../apis/apis";
const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    companyName: "",
    shippingAddress: "",
    primaryContact: "",
    accountingContact: "",
    taxExempt: "",
  });

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleLogin = async () => {
    console.log("Login with", loginData);
    // try {
    //   const countryData = await getCountryData(loginData.email);
    //   console.log(countryData);

    login();
    // } catch (error) {
    //   alert("Failed to fetch country data.");
    // }

    navigate("/main");
  };

  const handleRegister = () => {
    console.log("Registering with", registerData);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 2, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          {tabIndex === 0 ? "Login" : "Create Account"}
        </Typography>
        <Tabs value={tabIndex} onChange={handleTabChange} centered>
          <Tab label="Login" />
          <Tab label="Create Account" />
        </Tabs>

        {/* Login Form */}
        {tabIndex === 0 && (
          <Box sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label="Email"
              margin="normal"
              value={loginData.email}
              onChange={(e) =>
                setLoginData({ ...loginData, email: e.target.value })
              }
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              value={loginData.password}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
            />
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              onClick={handleLogin}
            >
              Login
            </Button>
          </Box>
        )}

        {/* Register Form */}
        {tabIndex === 1 && (
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              {/* Row 1 */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  margin="normal"
                  value={registerData.firstName}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      firstName: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  margin="normal"
                  value={registerData.lastName}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      lastName: e.target.value,
                    })
                  }
                />
              </Grid>

              {/* Row 2 */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Email"
                  margin="normal"
                  value={registerData.email}
                  onChange={(e) =>
                    setRegisterData({ ...registerData, email: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  margin="normal"
                  value={registerData.password}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      password: e.target.value,
                    })
                  }
                />
              </Grid>

              {/* Row 3 */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  margin="normal"
                  value={registerData.companyName}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      companyName: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Shipping Address"
                  margin="normal"
                  value={registerData.shippingAddress}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      shippingAddress: e.target.value,
                    })
                  }
                />
              </Grid>

              {/* Row 4 */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Primary Contact"
                  margin="normal"
                  value={registerData.primaryContact}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      primaryContact: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Accounting Contact"
                  margin="normal"
                  value={registerData.accountingContact}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      accountingContact: e.target.value,
                    })
                  }
                />
              </Grid>

              {/* Tax Exempt Field (Radio Buttons) */}
              <Grid item xs={12}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">Tax Exempt</FormLabel>
                  <RadioGroup
                    row
                    name="taxExempt"
                    value={registerData.taxExempt}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        taxExempt: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              onClick={handleRegister}
            >
              Create Account
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default LoginPage;
